import { Component, Input, OnInit } from '@angular/core';
import { Tenant } from '../../../../model/tenant';
import { TenantsService } from '../../../../services/tenants.service';
import { Decoder } from '../../../../model/decoder';

@Component({
  selector: 'app-tenant-decoders',
  templateUrl: './tenant-decoders.component.html',
  styleUrls: ['./tenant-decoders.component.scss']
})
export class TenantDecodersComponent implements OnInit {

  @Input()
  public tenant: Tenant;

  public decoders: Decoder[];
  public totalDecoders: number;
  public loadingDecoders: boolean;

  public rows = 10;
  public first = 0;

  constructor(private tenantsService: TenantsService) {}

  ngOnInit(): void {
    this.loadDecoders(this.first / this.rows, this.rows);
  }

  private loadDecoders(offset: number, limit: number): void {
    this.loadingDecoders = true;
    this.tenantsService.getTenantDecoders(this.tenant.uuid, offset, limit)
      .subscribe(response => {
        this.decoders = response.decoders.sort((a, b) => a.name > b.name ? 1 : -1);
        this.totalDecoders = response.totalElements;
        this.loadingDecoders = false;
      });
  }

  onPageChange(event): void {
    this.loadDecoders(event.first / event.rows, event.rows);
  }

}
